<nav class="w-full max-w-6xl mx-auto px-3 md:px-6 pt-3" dir="rtl">
  <section
    [class.fixed]="scrolled"
    [class.top-0]="scrolled"
    [class.right-0]="scrolled"
    [class.left-0]="scrolled"
    [class.z-40]="scrolled"
    class="nav flex justify-between items-center px-3 md:px-6 py-2 transition-shadow"
  >
    <button
      type="button"
      class="btn-2026--ghost !py-1.5 !px-3 !text-base"
      (click)="goBack()"
      aria-label="חזרה למסך הקודם"
    >
      <span class="material-symbols-outlined" aria-hidden="true">arrow_forward</span>
      חזרה
    </button>

    <button
      type="button"
      class="nav__logout btn-2026--ghost !py-1.5 !px-3 !text-base !text-danger !border-danger/40 hover:!bg-danger hover:!text-white"
      (click)="onLogout()"
      aria-label="התנתקות מהמערכת"
    >
      התנתק
      <span class="material-symbols-outlined rotate-180" aria-hidden="true">logout</span>
    </button>
  </section>
</nav>
